import React from 'react'

//Node Modules
import { useTranslation } from 'react-i18next'
import Modal from 'react-bootstrap/Modal'

//Components
import { CloseIcon } from 'components/SASIcon'

//Styles
import styles from './Modal.module.scss'

//Hooks
import { useIsSmallDevice } from 'hooks'

interface Props {
  show?: boolean
  hideCloseButton?: boolean
  onHide?: () => void
  onOk?: ()=>void
  onHideText?: string
  title?: string
  children: React.ReactNode
  scrollable?: boolean
  secureModal?: boolean
  aboutModal?: boolean
}

const SasModal = ({ show, title, children, onHide, onOk, onHideText='helpcenter-gui-icu.modal.cancel_button.title', hideCloseButton, scrollable, secureModal, aboutModal }:Props) => {
  const { t } = useTranslation()
  const isSmallDevice = useIsSmallDevice()

  var modalClassName = styles.modal
  
  if(secureModal) {
    if(isSmallDevice) {
      modalClassName = [styles.modal, styles.secureModal, styles.isSmallDevice].join(' ')
    } else {
      modalClassName = [styles.modal, styles.secureModal].join(' ')
    }
  }

  return (
    <>
      <Modal show={show} onHide={onHide} className={modalClassName} scrollable={scrollable} aria-labelledby='ModalTitle' backdropClassName={styles.backdrop}>
        <Modal.Header className={styles.header}>
          <Modal.Title className={styles.title} id='ModalTitle'>{title}</Modal.Title>
          <button type="button" className={`close ${styles.close}`} onClick={onHide} aria-label={t("helpcenter-gui-icu.modal.close_button.aria")}>
            <CloseIcon />
          </button>
        </Modal.Header>
        <Modal.Body className={styles.body}>
          { children }
        </Modal.Body>
        <Modal.Footer>
          { typeof onOk == 'function' ? <button className={styles.okButton} onClick={onOk}>{t("helpcenter-gui-icu.modal.ok_button.title")}</button> : null}
          { onHide && !hideCloseButton && 
            <button className={aboutModal ? styles.closeButtonLong : styles.closeButton} onClick={onHide}>
              {t(onHideText)}
            </button>
          }
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default SasModal